import React from 'react'
import { Container, TextTitle, ListContainer } from '@pmi/pmi-iqos-ds-react'
import { ProductCardBundle, ProductCardProduct } from '@zyn-common/components'

const ProductListGeneric = ({
  products,
  title,
  isBundleList,
  onAddToCart,
  ...rest
}) => {
  const getItem = (item, index) => {
    return (
      <Container
        key={index}
        alignItems={Container.alignItemsValues.center}
        justifyContent={Container.justifyContentValues.center}
        fullWidth
        fullHeight
        p="5">
        {isBundleList ? (
          <ProductCardBundle
            bundle={item}
            onAddToCart={bundle => {
              onAddToCart(bundle, index)
            }}
            {...rest}
          />
        ) : (
          <ProductCardProduct
            productPosition={index}
            product={item}
            onAddToCart={onAddToCart}
            {...rest}
          />
        )}
      </Container>
    )
  }

  const getProductItems = products => {
    return products.map((item, index) => {
      return getItem(item, index)
    })
  }

  return (
    <Container fullWidth>
      <Container py="12">
        <TextTitle
          heading={TextTitle.headings.h4}
          data-testing="ProductList_TextTitle_Title">
          {title}
        </TextTitle>
      </Container>
      <ListContainer columns={[1, 2, 3]} xBetween="8" yBetween="8">
        {getProductItems(products)}
      </ListContainer>
    </Container>
  )
}

export default ProductListGeneric
